<template>
  <div>
    <HeroBanner page="logged"/>
    <section class="container">
      <div class="columns">
        <div class="column is-one-fifth">
          <aside class="menu">
            <p class="menu-label">
              General
            </p>
            <ul class="menu-list">
              <li><a class="is-active">Dashboard</a></li>
            </ul>
            <p class="menu-label">
              Settings
            </p>
            <ul class="menu-list">
              <li><a>My informations</a></li>
              <li><a>Change password</a></li>
            </ul>
          </aside>
        </div>
        <div class="column">
          <p>Contenu</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
export default {
  components: {
    HeroBanner
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>
  .menu-label {
    margin-left: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageMyAccount.vue